(function (app) {

    app.provider("userRegistrationApi",
        [
            function () {
                this.$get = ["crmApiGateway", function (crmApiGateway) {
                    var service = {};
                    
                        service.getUserRegistration = function (userRegistrationId) {
                            return crmApiGateway.get("/UserRegistrations/" + userRegistrationId);
                        };

                        service.getUserRegistrationByToken = function (token) {
                            return crmApiGateway.get("/UserRegistrations/Token/" + token);
                        };

                        service.getAllIncompleteUserRegistrations = function () {
                            return crmApiGateway.getArray("/UserRegistrations/All");
                        }

                        service.completeUserRegistration = function (userRegistration) {
                            return crmApiGateway.put("/UserRegistrations/" + userRegistration.Id, userRegistration);
                        }

                        service.resendUserRegistration = function (userRegistrationId) {
                            return crmApiGateway.put("/UserRegistrations/Resend/" + userRegistrationId);
                        }

                        service.createUserRegistration = function (userRegistration) {
                            return crmApiGateway.post("/UserRegistrations/", userRegistration);
                        }

                        service.deleteUserRegistration = function (userRegistrationId) {
                            return crmApiGateway.delete("/UserRegistrations/Delete/" + userRegistrationId);
                        }

                    return service;
                }];
            }
        ]);
})(window.app); // jshint ignore:line